import { DELETE_VENDOR } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case DELETE_VENDOR.LOAD:
      return {
        ...state,
        loading: true,
      };
    case DELETE_VENDOR.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case DELETE_VENDOR.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
